import { useEffect, useState } from 'react';
import { GeoAutocompleteOption, SearchForm } from '../types';
import {
  getDepartureHistory,
  getDestinationHistory,
  getSearchHistory,
} from '../helpers/saveSearchHistory';

const useSearchHistory = () => {
  const [departureHistory, setDepartureHistory] = useState<GeoAutocompleteOption[]>([]);
  const [destinationHistory, setDestinationHistory] = useState<GeoAutocompleteOption[]>([]);
  const [searchHistory, setSearchHistory] = useState<SearchForm[]>([]);

  useEffect(() => {
    setDepartureHistory(getDepartureHistory());
    setDestinationHistory(getDestinationHistory());
    setSearchHistory(getSearchHistory());
  }, []);

  return {
    departureHistory,
    destinationHistory,
    searchHistory,
  };
};

export default useSearchHistory;
